<template>
    <div class="newscenter">
        <div class="c_banner">
            <div class="text_p_fixed">
              <div class="text_box">
                <div class="text1">历史铸就现在，现在成就未来</div>
                 <div class="text2">历史铸就现在，现在成就未来</div>
                  <div class="text3">为国内外用户建设优质高效的工程并提供周到满意的服务</div>
              </div>
          </div>
        </div>
        <div v-if="casenav.length" class="case_box">
            <div class="c_b_nav_c">
                <ul class="c_b_nav_l">
                    <li class="c_b_nav_btn" :class="{'add_c_b_nav_btn' :index==caseactive}"
                        v-for="(item,index) in casenav" :key="index" @click="casenav_func(index)">
                        {{item.cate_name}}
                    </li>
                </ul>
                <ul class="c_b_nav_r">
                    <li class="c_b_nav_r_btn" @click="linkHome">
                        首页 >
                    </li>
                    <li class="c_b_nav_r_btn">
                        新闻中心 >
                    </li>
                    <li class="c_b_nav_r_btn">
                        {{casenav[caseactive].cate_name}}
                    </li>
                </ul>
            </div>
            <!-- 新闻详情 -->
            <newslist v-show="!showlistb" ref="caselist" @gotohistory="gotohistory"></newslist>
            <!-- 新闻中心 -->
            <div class="c_list_center" v-show="showlistb">
                <ul class="c_l_c_ul">
                    <li class="c_l_c_li" v-for="(item,index) in newsList" :key='index' @click="navtocaselist($event,item.id)">
                        <div class="li_img_box">
                            <img :src="item.news_headpic" alt="">
                        </div>
                        <div class="li_title">
                            <div class="l_t_text">
                                {{item.news_title}}
                            </div>
                            <div class="l_t_time">
                                {{item.create_time}}
                            </div>
                            <div class="l_t_content">
                                {{item.news_brief}}
                            </div>
                        </div>
                        <div class="li_text">
                            了解详情 >
                        </div>
                    </li>
                </ul>
                <div class="page_box">
                    <el-pagination :page-size="page.limit" layout="total, prev, pager, next" :total="page.total" @current-change="handleSizeChange">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div class="mb190"></div>
    </div>
</template>

<script>
    import newslist from "./newslist";
    import {
        getNewsList,
        getNavList
    } from '../../api/apis.js'
    export default {
        name: 'Newscenter',
        data() {
            return {
                //分页
                page: {
                    current_page: 1,
                    limit: 6,
                    last_page: 1,
                    total: ''
                },
                newsList:[],
                showlistb: true,
                caseactive: 0,
                casenav: []
            }
        },
        components: {
            newslist,
        },
        mounted() {
            getNavList().then(res => {
                let navBanner = [];
                let cate = [];
                let navList = [
                    { id: 0, title: "首页", path: "/" },
                    { id: 0, title: "业务范围", path: "/busines" },
                    { id: 0, title: "公司简介", path: "/brief" },
                    { id: 0, title: "工程案例", path: "/casecenter" },
                    { id: 0, title: "新闻中心", path: "/newscenter" },
                    { id: 0, title: "人才招聘", path: "/talent" },
                    { id: 0, title: "联系我们", path: "/concat" }
                ];
                res.forEach((item, index) => {
                    navList[index].id = item.id;
                    navList[index].title = item.cate_name;
                    navBanner[index] = item.cate_img;
                    cate.push(item.next_cate);
                });
                console.log(cate,'dddddd')
                this.casenav = cate[4];
                this.getList();
            })

        },
        methods: {
            linkHome(){
                this.$router.push({path:'/'})
            },
            //改变路由按钮颜色
            casenav_func(index) {
                this.caseactive = index;
                this.initPage();
                //请求新闻列表
                this.getList();
            },
            //显示案例详情
            navtocaselist(e, id) {
                this.showlistb = !this.showlistb;
                switch (this.caseactive) {
                    case 0:
                        this.$refs.caselist.getindex('返回公司新闻', this.caseactive, id);//通过ref触发子组件caselist中getindex方法
                        break;
                    case 1:
                        this.$refs.caselist.getindex('返回行业新闻', this.caseactive, id);
                        break;
                    default:
                        break;
                }
            },
            //接受子组件参数，返回上一级；
            gotohistory(data) {
                if (data) {
                    this.showlistb = true;
                }
            },
            getList() {
                let index = this.caseactive;
                // console.log('index2',index,this.page.current_page);
                if (this.page.current_page <= this.page.last_page) {
                    // this.page.current_page = ++this.page.current_page;
                    getNewsList({
                        pid: this.casenav[index].pid,
                        page: this.page.current_page,
                        limit: this.page.limit
                    }).then(res => {
                        this.newsList = res.data;
                        let page = {
                            current_page: res.current_page,
                            limit: 6,
                            last_page: res.last_page,
                            total: res.total
                        };
                        this.page = page;
                    })
                }
            },
            //初始化page
            initPage() {
                this.page = {
                    current_page: 0,
                    limit:6,
                    last_page: 1,
                };
                this.newsList = [];
            },
            handleSizeChange(page){
                this.page.current_page = page;
                this.getList();
            },
        },
    }
</script>
<style scoped lang="scss">
    .show{
        height: 1200px;
    }
    .newscenter {
        // border:1px solid red;
        width: 100%;
        background: #ffffff;

        .c_banner {
            border-top: 1px solid #ffffff;
            height: 500px;
            width: 100%;
            min-width: 1200px;
            margin: 0 auto;
            background: url('../../assets/c3.png') no-repeat;
            background-size: 100% 500px;

            .text_p_fixed {
                //  border:1px solid red;
                width: 1200px;
                height: 500px;
                margin: 0 auto;

                .text_box {
                    //  border:1px solid red;
                    width: 870px;
                    height: 200px;
                    margin-left: 180px;
                    margin-top: 104px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    .text1 {
                        width: 870px;
                        height: 64px;
                        font-size: 64px;
                        font-family: RTWS ShangYa Demo;
                        font-weight: normal;
                        line-height: 85px;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                    }

                    .text2 {
                        width: 674px;
                        height: 37px;
                        font-size: 28px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 37px;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                    }

                    .text3 {
                        width: 554px;
                        height: 34px;
                        background: rgba(255, 255, 255, 1);
                        opacity: 0.8;
                        width: 524px;
                        height: 26px;
                        font-size: 20px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 26px;
                        color: rgba(97, 139, 187, 1);
                    }
                }
            }
        }

        .case_box {
            // border:1px solid yellow;
            width: 1200px;
            // height: 1200px;
            margin: 0 auto;
            .c_b_nav_c {
                width: 1200px;
                height: 64px;
                background: rgba(242, 242, 242, 1);
                display: flex;
                justify-content: space-between;
                align-items: center;

                .c_b_nav_l {
                    // border:1px solid red;
                    // width: 640px;
                    height: 64px;
                    display: flex;
                    justify-content: space-between;

                    .c_b_nav_btn {
                        //  border:1px solid red;
                        width: 160px;
                        height: 64px;
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 64px;
                        text-align: center;
                        color: rgba(102, 102, 102, 1);
                        opacity: 1;
                        cursor: pointer;
                    }

                    .c_b_nav_btn:hover {
                        color: #ffffff;
                        background: #1584F5;
                    }

                    .add_c_b_nav_btn {
                        color: #ffffff;
                        background: #1584F5;
                    }
                }

                .c_b_nav_r {
                    display: flex;
                    justify-content: space-around;
                    color: #999999;
                    font-size: 16px;
                    margin-right: 15px;

                    .c_b_nav_r_btn {
                        cursor: pointer;
                    }
                }

            }

            .c_list_center {
                // border:1px solid red;
                width: 1200px;
                // height: 1130px;
                display: flex;
                justify-content: space-around;
                flex-direction: column;

                .c_l_c_ul {
                    // border:1px solid green;
                    width: 1200px;
                    //  height: 1030px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    margin-bottom: 60px;

                    // margin-top: 40px;
                    .c_l_c_li {
                        //  border:1px solid green;
                        width: 1200px;
                        height: 316px;
                        background: rgba(255, 255, 255, 1);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 1px dashed #CECECE;

                        // box-shadow:0px 4px 8px rgba(0,0,0,0.32);
                        // opacity:1;
                        // border-radius:4px;
                        .li_img_box {
                            width: 310px;
                            height: 220px;
                            overflow: hidden;

                            img {
                                width: 310px;
                                height: 220px;
                                transition: all 0.5s;
                            }
                        }

                        .li_img_box:hover img {
                            transform: scale(1.5);
                        }

                        .li_title {
                            // border:1px solid red;
                            width: 690px;
                            height: 220px;
                            display: flex;
                            justify-content: space-around;
                            flex-direction: column;

                            .l_t_text {
                                // border:1px solid red;
                                height: 24px;
                                font-size: 18px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 24px;
                                color: rgba(27, 91, 160, 1);
                                opacity: 1;
                            }

                            .l_t_time {
                                height: 19px;
                                font-size: 14px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 19px;
                                color: rgba(153, 153, 153, 1);
                                opacity: 1;
                            }

                            .l_t_content {
                                //   border:1px solid red;
                                height: 129px;
                                font-size: 16px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 26px;
                                color: rgba(51, 51, 51, 1);
                                min-height: 129px;
                                opacity: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 5;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .li_text {
                            //  border:1px solid red;
                            width: 139px;
                            height: 42px;
                            background: rgba(21, 132, 245, 1);
                            opacity: 1;
                            border-radius: 4px;
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 42px;
                            color: rgba(255, 255, 255, 1);
                            text-align: center;
                            opacity: 1;
                            cursor: pointer;
                        }
                    }
                }

                .page_box {
                    // border:1px solid pink;
                    width: 1200px;
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 60px;
                }
            }
        }
    }
</style>